import './bootstrap';
import '../css/app.css';

import { createRoot } from 'react-dom/client';
import {createInertiaApp, usePage} from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import {SurveySessionContextProvider} from "@/Context/SurveySessionContext";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {PageProps} from "@/types";
import {
    InputType,
    Node as SomatNode,
    NodeType,
    OptionGroup,
    SequenceType,
    SessionMode,
    Survey,
    SurveySession
} from "@/types/models";
import {SurveyEditInertiaProps} from "@/Pages/Admin/Survey/Edit";
import {UploadedFilesContextProvider} from "@/Context/UploadedFilesContext";

const appName = import.meta.env.VITE_APP_NAME || 'SOMAT';

export interface SurveySessionInertiaProps {
    session?: SurveySession
    initialNode?: SomatNode
    nodeTypes?: NodeType[]
    inputTypes?: InputType[]
    optionGroups?: OptionGroup[]
    sequenceTypes?: SequenceType[],
    mode?: SessionMode,
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.tsx`, import.meta.glob('./Pages/**/*.tsx')),
    setup({ el, App, props }) {
        const root = createRoot(el);
        const queryClient = new QueryClient();

        if(props.initialPage.props.variant?.classes){
            for (const [key, value] of Object.entries(props.initialPage.props.variant.classes)) {
                if(key.startsWith("--") && !el.style.getPropertyValue(key)) {
                    el.style.setProperty(key, value)
                }
            }
        }

        root.render(
            <QueryClientProvider client={queryClient}>
                <SurveySessionContextProvider {...props.initialPage.props}>
                    <UploadedFilesContextProvider {...props.initialPage.props}>
                        <App {...props} />
                    </UploadedFilesContextProvider>
                </SurveySessionContextProvider>
            </QueryClientProvider>
        );
    },
    progress: {
        color: '#4B5563',
    },
});
